export const trainHomeEn = {
    mainfei:"free",
    kechengjiage:"Price of course",
    kechengjieshu:"Course section number",
    bofangliang:"Amount of play",
    zongshichang:"The total length",
    vipFree:"VIP free viewing",
    goumaikecheng:"Purchase of course",
    lijibofang:"Play immediately",
    fenxiang:"share",
    peixunxiangqing:"Training details",
    peixunpinglun:"Training comments",
    guankanwangzhengsp:'Watch the full video'
}


// WEBPACK FOOTER //
// ./src/lang/home/trainHome/indexEn.js